import * as Tooltip from "@radix-ui/react-tooltip";
import { Lock } from "lucide-react";
import { cn } from "@ds/lib/utils";

/**
 * CipherChip — menampilkan FLOOR sebagai sandi huruf (mis. "JM"), TIDAK pernah
 * angka modal (Aturan Emas §1–§2, rfc-002). Komponen ini hanya merender string
 * sandi yang sudah dihitung util `shared/`; ia tak tahu modal mentah.
 *
 * Yang tahu kunci tahu artinya; yang tidak tahu hanya tahu "ada batas".
 * Mono + tabular agar konsisten. Tooltip menjelaskan tanpa membocorkan angka.
 */
export interface CipherChipProps {
  /** Sandi floor terhitung, mis. "JM". */
  cipher: string;
  /** Tampilkan prefix label "floor:". Default true. */
  showLabel?: boolean;
  size?: "sm" | "md";
  className?: string;
}

export function CipherChip({
  cipher,
  showLabel = true,
  size = "md",
  className,
}: CipherChipProps) {
  return (
    <Tooltip.Provider delayDuration={200}>
      <Tooltip.Root>
        <Tooltip.Trigger asChild>
          <span
            className={cn(
              "inline-flex items-center gap-1 rounded-sm border border-border bg-surface-2",
              "font-mono font-medium tracking-wide text-ink cursor-help",
              size === "sm" ? "h-5 px-1.5 text-[0.6875rem]" : "h-6 px-2 text-xs",
              className,
            )}
            aria-label={`Batas harga (sandi) ${cipher}`}
          >
            <Lock className="size-3 text-muted" aria-hidden />
            {showLabel && <span className="text-muted font-sans">floor:</span>}
            <span className="tabular-nums">{cipher}</span>
          </span>
        </Tooltip.Trigger>
        <Tooltip.Portal>
          <Tooltip.Content
            sideOffset={6}
            className={cn(
              "z-tooltip max-w-[15rem] rounded-md border border-border bg-surface px-3 py-2",
              "text-[0.8125rem] text-ink shadow-[var(--shadow-toast)] pop-in",
            )}
          >
            Batas harga dalam sandi. Yang memegang kunci tahu artinya; harga jual
            tak boleh di bawah batas ini.
            <Tooltip.Arrow className="fill-[var(--surface)]" />
          </Tooltip.Content>
        </Tooltip.Portal>
      </Tooltip.Root>
    </Tooltip.Provider>
  );
}
